import defaultThumbnail from '../../../../../../../../../../assets/images/map/thumbnail.png';

export const DefaultResourceThumbnail = defaultThumbnail;
export const getImageAbsoluteURL = (link: string, imageURL?: string) => {
    if (!imageURL) {
        return defaultThumbnail;
    }

    if (imageURL.startsWith('http')) {
        return imageURL;
    }
    const origin = new URL(link).origin;
    return new URL(imageURL, origin).href;
};
